
<div class="pie-graph">
  <div class="card">
    <h4 v-if="title">{{ title }}</h4>

    <div class="graph-container">
      <pie-chart
        :key="$route.name"
        :chart-data="chartData"
        :options="chartOptions"
      />
    </div>

    <div class="legend" v-if="legend.length > 1">
      <span class="legend-set" v-for="(set, i) in legend" :key="i">
        <span class="legend-dot" :style="{ 'background-color': set.color }" />
        <span>{{ set.label }}</span>
      </span>
    </div>
  </div>
</div>
